export default "__VITE_ASSET__cmR8fTeV__"